// extracted by mini-css-extract-plugin
export default {"imageStripContainer":"TkBmnzoZBbghD2ped4Ri"};